import React from "react";
import { Helmet } from "react-helmet-async";
import { Container, Card } from "react-bootstrap";
import "./LegalPages.css";

export default function Disclaimer() {
    const siteName = "Shivay Tour & Travells";
    const siteUrl = "https://www.shivaytourandtravells.com";
    const contactEmail = "shivaytourandtravells@gmail.com";
    const effectiveDate = "October 6, 2025";

    return (
        <Container className="legal-page my-5">
            <Helmet>
                <title>Disclaimer | {siteName}</title>
                <meta
                    name="description"
                    content={`Read the Disclaimer for ${siteName}. Learn about information accuracy, liability limits, and travel-related advice.`}
                />
            </Helmet>

            <div className="text-center mb-5">
                <h1 className="legal-heading">Disclaimer</h1>
                <p className="lead text-secondary">Effective Date: {effectiveDate}</p>
            </div>

            <Card className="p-4 shadow-lg border-0 rounded-4">
                <p>
                    The information provided on <a href={siteUrl}>{siteUrl}</a> (“we,” “us,” or “our”) is published in good faith
                    and for general informational purposes only. {siteName} makes no warranties, express or implied, about the
                    accuracy or reliability of any information contained herein.
                </p>

                <section>
                    <h3>1. External Links Disclaimer</h3>
                    <p>
                        Our website may contain links to external sites not maintained or affiliated with {siteName}. We do not
                        guarantee the accuracy or reliability of information on these third-party websites. Visiting such links is
                        at your own discretion and risk.
                    </p>
                </section>

                <section>
                    <h3>2. Travel Information Disclaimer</h3>
                    <p>
                        Travel information such as destinations, packages, and pricing is subject to change without notice. You are
                        responsible for verifying visa requirements, transport schedules, and government advisories before travel.
                    </p>
                </section>

                <section>
                    <h3>3. Affiliate Disclosure</h3>
                    <p>
                        Some pages on {siteName} may contain affiliate links. We may earn a small commission if you make a purchase
                        or booking through those links — at no additional cost to you. These commissions help us maintain and
                        improve our services.
                    </p>
                </section>

                <section>
                    <h3>4. No Professional Advice</h3>
                    <p>
                        All travel tips, itineraries, and guides shared on this website are for informational purposes only. They do
                        not substitute for professional travel or legal advice. Always verify plans with licensed professionals or
                        authorities.
                    </p>
                </section>

                <section>
                    <h3>5. Limitation of Liability</h3>
                    <p>
                        In no event shall {siteName} be liable for any loss or damage — including indirect or consequential losses —
                        arising out of or in connection with the use of our website or services.
                    </p>
                </section>

                <section>
                    <h3>6. Consent</h3>
                    <p>
                        By using our website, you hereby consent to our disclaimer and agree to all its terms and conditions.
                    </p>
                </section>

                <section>
                    <h3>7. Updates</h3>
                    <p>
                        This disclaimer may be updated periodically. Any modifications will be posted on this page with a revised
                        effective date.
                    </p>
                </section>

                <section>
                    <h3>8. Contact Us</h3>
                    <p>
                        For any questions about this Disclaimer, please contact us at:{" "}
                        <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
                    </p>
                </section>

                <p className="text-muted small text-center mt-4">
                    Last Updated: {effectiveDate}
                </p>
            </Card>
        </Container>
    );
}
